window.dtPresenceMachineLogDetail = function () {
  const tableSelector = "#presence-machine-log-detail-datatable";

  const dtPresenceMachineLogDetail = new DataTable(tableSelector, {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $(tableSelector).data("source"),
      beforeSend: function () { showLoadingRow(tableSelector, 6); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[5, "asc"], [2, "desc"], [3, "desc"]],
    columns: [
      { data: "machine" },
      { data: "pin" },
      { data: "date" },
      { data: "time" },
      { data: "kind" },
      { data: "process" }
    ],
    language: {
      search: " ",
      sLengthMenu: "_MENU_",
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row) {
      $("td", row).addClass("py-1");
    }
  });

  dtFinalTouch();
}

$(document).off("click", "#btn-process-machine-log-items");
$(document).on("click", "#btn-process-machine-log-items", function () {
  const tableSelector = "#presence-machine-log-detail-datatable";
  const processUrl = $(tableSelector).data("process-url");
  if (!processUrl) { return true; }

  Notiflix.Confirm.show(
    "Konfirmasi",
    "Process semua log belum diproses?",
    "Ya",
    "Batal",
    function () {
      $.ajax({
        url: processUrl,
        method: "POST",
        headers: { "X-CSRF-Token": $("meta[name='csrf-token']").attr("content") },
        dataType: "json",
        success: function (data) {
          if (data.href) {
            loadPage(data.href, false);
          }
          if (data.message) {
            Notiflix.Notify.success(data.message, { position: "right-bottom", useIcon: false });
          }
        },
        error: function (jqXHR) {
          Notiflix.Notify.failure(jqXHR.responseJSON.message, { position: "right-bottom", useIcon: false });
        }
      });
    },
    function () {}
  );
});
